import { supabase } from '../client';
import type { CreateIncidentRequest, IncidentActionRequest } from '@munawb/types';

// ==============================
// إنشاء حدث جديد (عبر Edge Function لتشغيل Quality Rules)
// ==============================
export async function createIncident(data: CreateIncidentRequest & { reporter_name: string }) {
  const { data: result, error } = await supabase.functions.invoke('incidents-create', {
    body: data,
  });
  if (error) throw error;
  return result;
}

// ==============================
// تنفيذ إجراء على حدث
// ==============================
export async function performIncidentAction(data: IncidentActionRequest) {
  const { data: result, error } = await supabase.functions.invoke('incidents-action', {
    body: data,
  });
  if (error) throw error;
  return result;
}

// ==============================
// حذف ناعم (Admin فقط)
// ==============================
export async function softDeleteIncident(incident_id: string) {
  const { error } = await supabase
    .from('incidents')
    .update({ deleted_at: new Date().toISOString() })
    .eq('id', incident_id);

  if (error) throw error;
}
